import { Badge } from "../components/ui/Badge";
import { EmptyState, ErrorState, Skeleton } from "../components/ui/Feedback";
import { TBody, TD, TH, THead, TR, Table } from "../components/ui/Table";
import { useLocations } from "../features/locations/useLocations";
import { formatNumber } from "../lib/format";

export const LocationsPage = () => {
	const query = useLocations();

	return (
		<div className="space-y-6">
			<div>
				<h2 className="text-xl font-semibold tracking-tight text-ink">Locations</h2>
				<p className="mt-1 text-sm text-ink-muted">
					Stock locations synced from Shopify, with tracked inventory totals.
				</p>
			</div>

			{query.isError ? (
				<ErrorState title="Could not load locations" description={query.error.message} />
			) : null}

			{query.isPending ? <Skeleton className="h-40 w-full" /> : null}

			{query.data && query.data.items.length === 0 ? (
				<EmptyState
					title="No locations yet"
					description="Locations appear after the first inventory sync completes."
				/>
			) : null}

			{query.data && query.data.items.length > 0 ? (
				<div className="overflow-hidden rounded-md border border-line">
					<Table>
						<THead>
							<TR>
								<TH>Location</TH>
								<TH className="w-28">Status</TH>
								<TH className="w-40">Tracked variants</TH>
								<TH className="w-40">Available units</TH>
							</TR>
						</THead>
						<TBody>
							{query.data.items.map((location) => (
								<TR key={location.id} className="hover:bg-raised">
									<TD className="font-medium">{location.name ?? "Unnamed location"}</TD>
									<TD>
										<Badge variant={location.isActive ? "solid" : "outline"}>
											{location.isActive ? "Active" : "Inactive"}
										</Badge>
									</TD>
									<TD className="text-ink-muted">{formatNumber(location.trackedVariants)}</TD>
									<TD>{formatNumber(location.availableUnits)}</TD>
								</TR>
							))}
						</TBody>
					</Table>
				</div>
			) : null}
		</div>
	);
};
